'use strict'

# What this module exports
module.exports =
	filters:
		'rtble_temperature': require('./rtble_temperature')
